module.exports = __webpack_public_path__ + "static/img/200195.b3741eab.png";